import { render, staticRenderFns } from "./BrokerCheck.vue?vue&type=template&id=1c509bd8&scoped=true"
import script from "./BrokerCheck.vue?vue&type=script&lang=js"
export * from "./BrokerCheck.vue?vue&type=script&lang=js"
import style0 from "./BrokerCheck.vue?vue&type=style&index=0&id=1c509bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c509bd8",
  null
  
)

export default component.exports